import { render, staticRenderFns } from "./KCustomFieldListItem.vue?vue&type=template&id=96d83570&scoped=true&lang=pug&"
import script from "./KCustomFieldListItem.vue?vue&type=script&lang=js&"
export * from "./KCustomFieldListItem.vue?vue&type=script&lang=js&"
import style0 from "./KCustomFieldListItem.vue?vue&type=style&index=0&id=96d83570&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d83570",
  null
  
)

export default component.exports